import script from "./Component-stories-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Component-stories-item.vue?vue&type=script&setup=true&lang=js"

import "./Component-stories-item.vue?vue&type=style&index=0&id=6828632d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6828632d"]])

export default __exports__